import * as transform from './transform';
import { forAxisTicks } from './util';

export const COLOR_BAND = '#EDEEEF';
export const VIDEO_COLOR_BAND = '#444444';
const COLOR_LABEL_VER = '#666666';//'rgba(0, 0, 0, 0.2)';
const COLOR_LABEL_HOR = '#666666';//#727272
const MARGIN_VER = 8;
const MARGIN_HOR = 2;
const OFFSET = 0;//-0.38;

// Data from http://www.nber.org/cycles.html
export const RECESSIONS = [
  { start: { month: 5, year: 1857 }, end: { month: 11, year: 1858 } },
  { start: { month: 9, year: 1860 }, end: { month: 5, year: 1861 } },
  { start: { month: 3, year: 1865 }, end: { month: 11, year: 1867 } },
  { start: { month: 5, year: 1869 }, end: { month: 11, year: 1870 } },
  { start: { month: 9, year: 1873 }, end: { month: 2, year: 1879 } },
  { start: { month: 2, year: 1882 }, end: { month: 4, year: 1885 } },
  { start: { month: 2, year: 1887 }, end: { month: 3, year: 1888 } },
  { start: { month: 6, year: 1890 }, end: { month: 4, year: 1891 } },
  { start: { month: 0, year: 1893 }, end: { month: 5, year: 1894 } },
  { start: { month: 11, year: 1895 }, end: { month: 5, year: 1897 } },
  { start: { month: 5, year: 1899 }, end: { month: 11, year: 1900 } },
  { start: { month: 8, year: 1902 }, end: { month: 7, year: 1904 } },
  { start: { month: 4, year: 1907 }, end: { month: 5, year: 1908 } },
  { start: { month: 0, year: 1910 }, end: { month: 0, year: 1912 } },
  { start: { month: 0, year: 1913 }, end: { month: 11, year: 1914 } },
  { start: { month: 7, year: 1918 }, end: { month: 2, year: 1919 } },
  { start: { month: 0, year: 1920 }, end: { month: 6, year: 1921 } },
  { start: { month: 4, year: 1923 }, end: { month: 6, year: 1924 } },
  { start: { month: 9, year: 1926 }, end: { month: 10, year: 1927 } },
  { start: { month: 7, year: 1929 }, end: { month: 2, year: 1933 } },
  { start: { month: 4, year: 1937 }, end: { month: 5, year: 1938 } },
  { start: { month: 1, year: 1945 }, end: { month: 9, year: 1945 } },
  { start: { month: 10, year: 1948 }, end: { month: 9, year: 1949 } },
  { start: { month: 6, year: 1953 }, end: { month: 4, year: 1954 } },
  { start: { month: 7, year: 1957 }, end: { month: 3, year: 1958 } },
  { start: { month: 3, year: 1960 }, end: { month: 1, year: 1961 } },
  { start: { month: 11, year: 1969 }, end: { month: 10, year: 1970 } },
  { start: { month: 10, year: 1973 }, end: { month: 2, year: 1975 } },
  { start: { month: 0, year: 1980 }, end: { month: 6, year: 1980 } },
  { start: { month: 6, year: 1981 }, end: { month: 10, year: 1982 } },
  { start: { month: 6, year: 1990 }, end: { month: 2, year: 1991 } },
  { start: { month: 2, year: 2001 }, end: { month: 10, year: 2001 } },
  { start: { month: 11, year: 2007 }, end: { month: 5, year: 2009 } }
];


/**
 * Pre Render
 */
export function preRender(data, options) {
  if (canShowRecessions(options)) {
    const values = convertDataToValues();
    const dateA = options.dates[0];
    const dateB = options.dates[options.dates.length - 1];
    const axisValueA = (new Date(dateA.year, dateA.month || 0)).valueOf();
    const axisValueB = (new Date(dateB.year, dateB.month || 0)).valueOf();

    let conditionalColorBand;
    if (options.product === 'marketwatch') {
      conditionalColorBand = '#eeeff0';
    } else if (options.id === 'video') {
      conditionalColorBand = VIDEO_COLOR_BAND;
    } else {
      conditionalColorBand = COLOR_BAND;
    }

    let plotBands = values.map(v => {
      if (v.start <= axisValueB && v.end >= axisValueA) {
        return {
          from: Math.max(axisValueA, v.start),
          to: Math.min(axisValueB, v.end),
          color: conditionalColorBand,
          className: 'recession'
        };
      }
      return null;
    }).filter(item => {
      return item !== null;
    });

    if (plotBands.length) {
      if (options.quarterlyResults  && options.series[0].data.length <= 44) {
        plotBands = convertDatetimeToLinear(plotBands, options.dates);
      }
      data.xAxis.plotBands = [...data.xAxis.plotBands, ...plotBands];
    }
  }
  return data;
}


function canShowRecessions(options) {
  return options.axes.showRecessions &&
    options.dates &&
    options.type !== 'pie' &&
    options.type !== 'bar' &&
    allHaveYears(options.dates);
}

function allHaveYears(dates) {
  return !dates.some(date => {
    return date.year === undefined;
  })
}

function convertDataToValues() {
  return RECESSIONS.map(r => {
    return {
      start: (new Date(r.start.year, r.start.month)).valueOf(),
      end: (new Date(r.end.year, r.end.month)).valueOf()
    };
  });
}


// On datetime axes, values are milliseconds. On linear axes, values are
// just indices. For quarterly results, the axis is actually linear and just
// pretends to be datetime, so plotBands must be converted from datetime.
function convertDatetimeToLinear(plotBands, dates) {
  const datesLen = dates.length;
  plotBands.forEach(pb => {
    let newFrom = 0;
    let newTo = datesLen - 1;
    dates.forEach((date, index) => {
      if (pb.from >= date.value) {
        newFrom = index;
      }
      if (pb.to >= date.value) {
        newTo = index;
      }
    });
    newFrom = getLinearPrecise(newFrom, pb.from, dates);
    newTo = getLinearPrecise(newTo, pb.to, dates);
    pb.from = newFrom;
    pb.to = newTo;
  });
  return plotBands;
}

// For use with convertDatetimeToLinear().
function getLinearPrecise(linear, datetime, dates) {
  if (linear < dates.length - 1) {
    linear += (datetime - dates[linear].value) /
      (dates[linear + 1].value - dates[linear].value);
  }
  return linear;
}


/**
 * Post Render
 */
export function postRender(highchart, options) {
  var xAxis = highchart.xAxis[0];
  var pb = xAxis.plotLinesAndBands.filter(band => band.options.className === 'recession');

  if (pb.length) {
    let pos = null;
    let rtext = null;
    let maxPx = 0;

    if (options.type === 'bar') {
      pos = {
        x: highchart.plotLeft + highchart.plotWidth - MARGIN_HOR,
        y: highchart.plotTop + parseFloat(options.styles.small.fontSize)
      };
      rtext = writeRecessionText(highchart, options, pos, COLOR_LABEL_HOR);
      rtext.element.setAttribute('x', +rtext.element.getAttribute('x') -
        rtext.element.getBoundingClientRect().width);
      maxPx = highchart.plotTop + highchart.plotHeight;
      
      moveRecessionTextHorizontal(pb, rtext.element, maxPx);

    } else {
      if (options.ticksOffsetX) {
        offsetPlotBands(pb, options.ticksOffsetX);
      }
      pos = topYAxisLabelPosition(highchart, options);
      rtext = writeRecessionText(highchart, options, pos, COLOR_LABEL_VER);
      maxPx = highchart.plotLeft + highchart.plotWidth;
      moveRecessionTextVertical(pb, rtext.element, options.ticksOffsetX || 0, maxPx);
    }
  }
}


function offsetPlotBands(plotBands, offsetX) {
  plotBands.forEach(pb => {
    transform.write(pb.svgElem.element, 'translate', offsetX);
  })
}


function moveRecessionTextHorizontal(pb, el, maxY) {
  let y = + el.getAttribute('y');
  const origY = y;
  const elHeight = el.getBoundingClientRect().height + MARGIN_HOR;
  for (let i = 0; i < pb.length; i++) {
    if (!pb[i].svgElem) continue;
    const d = transform.read(null, 'd', pb[i].svgElem.d);
    if (d[2][1] - d[1][1] >= elHeight) {
      y = d[2][1] - MARGIN_HOR;
      break;
    } else if (i === pb.length - 1) {
      y = d[1][1] - MARGIN_HOR;
    }
  }
  el.setAttribute('y', Math.max(origY, Math.min(y, maxY - elHeight)));
}


function moveRecessionTextVertical(pb, el, offsetX, maxX) {
  const elWidth = el.getBoundingClientRect().width;
  let x = +el.getAttribute('x');
  for (let i = 0; i < pb.length; i++) {
    if (!pb[i].svgElem) continue;
    const d = transform.read(null, 'd', pb[i].svgElem.d);
    if (d[0][0] >= x) {
      x = d[0][0];
      break;
    } else if (d[2][0] >= x + elWidth) {
      x = d[2][0] - elWidth;
      break;
    }
  }
  x += offsetX;
  el.setAttribute('x', Math.min(x, maxX - elWidth));
}


function writeRecessionText(highchart, options, pos, color) {
  if ((options.product === 'marketwatch' || options.product === 'financialnews') && options.type === 'line') {
    let bandsX = highchart.container.getElementsByClassName('highcharts-plot-bands-0')[0].getBoundingClientRect();
    bandsX = bandsX.left - bandsX.width;
    pos.x = bandsX;
  }

  let css = options.styles.get('normal', { color: color });

  if (__WSJ__) {
    if (options.product === 'wsj') {
      css.fontSize = "13px";
      css.fontFamily = "Retina Narrow"

      if (options.print) {
        css.fontSize = "7.5px";
      }

      if (options.id === 'video') {
        css.fontSize = '32px';
        css.fontFamily = 'Retina Narrow';
        css.fontWeight = 400;
      }
    }

  }

  const regex = /[\u3000-\u303F]|[\u3040-\u309F]|[\u30A0-\u30FF]|[\uFF00-\uFFEF]|[\u4E00-\u9FAF]|[\u2605-\u2606]|[\u2190-\u2195]|\u203B/g;
  let recessionLabel = 'RECESSION';
  if (regex.test(options.el.innerHTML)) recessionLabel = 'リセッション';
  const text = options.product === 'barrons' ?
    'Recessions are shaded' : recessionLabel;

  return highchart.renderer.text(text, pos.x, pos.y)
    .css(css)
    .attr('class', 'label-recession')
    .add();
}


// Finds the Y of the top label on the y-axis in order to align "recession"
// on the same baseline. If units have been set, uses that as a shortcut.
function topYAxisLabelPosition(highchart, options) {
  let pos = { x: 0, y: 0 };
  const textUnits = highchart.container.querySelector('text.units');
  if (textUnits) {
    pos.x = +textUnits.getAttribute('x') +
      textUnits.getBoundingClientRect().width;
    pos.y = +textUnits.getAttribute('y') - 1;
  } else {
    forAxisTicks(highchart.yAxis[0], tick => {
      if (tick.isLast) {
        pos.x = +tick.label.element.getAttribute('x') +
          tick.label.element.getBoundingClientRect().width;
        pos.y = +tick.label.element.getAttribute('y');
        return false;
      }
    });
  }

  if (__WSJ__) {
    if (options.product === 'wsj' && options.print) {
      pos.y = pos.y + 1;
    }

  }

  pos.x += MARGIN_VER;
  return pos;
}



// WEBPACK FOOTER //
// ./src/chart/inner/recessions.js